export const DATA_TABLE_FILED_TYPE = [
  { id: 'file', key: 'data-tables.field-types.file' },
  { id: 'image', key: 'data-tables.field-types.image' },
  { id: 'month', key: 'data-tables.field-types.month' },
  { id: 'number', key: 'data-tables.field-types.number' },
  { id: 'tel', key: 'data-tables.field-types.tel' },
  { id: 'text', key: 'data-tables.field-types.text' },
  { id: 'time', key: 'data-tables.field-types.time' },
  { id: 'url', key: 'data-tables.field-types.url' },
];

export const FIELD_TYPES_WITHOUT_LENGTH = ['url', 'file', 'image'];
